import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useTranslation } from 'react-i18next';

export default forwardRef(({
    id = null,
    fetchOptions = (term) => { },
    labelKey = (option) => { },
    onNext = () => { },
    onBack = () => { },
    disabled = false,
    placeholder = "",
    name,
    minLength = 2,
    onChange = (selected) => { },
    onInputChange = (text) => { },
    onBlur = (e) => { },
    defaultSelectedOptions = [],
    inputProps = {}
}, ref) => {
    const [options, setOptions] = useState(defaultSelectedOptions ?? []);
    const [isLoading, setIsLoading] = useState(false);
    const reference = useRef();
    const { t } = useTranslation();
    const onSearch = async (term) => {
        setIsLoading(true);

        try {
            const result = await fetchOptions(term)
            setOptions(result)
        } catch (e) {
            setOptions([])
        }

        setIsLoading(false);
    }
    const onKeyDown = (e) => {
        if (e.key == 'Escape' || e.keyCode == 27) {
            reference.current.getInstance().clear()
            if (onChange != null) onChange(null)
            if (onBack != null) onBack()
        }
        if ((e.key == 'Enter' || e.keyCode == 13) && onNext != null) {
            onNext()
        }
    }

    useImperativeHandle(ref, () => ({
        clear: () => {
            reference.current.getInstance().clear()
        },
        focus: () => {
            reference.current.getInstance().focus()
        },
        inputValue: () => {
            return reference.current.getInstance().getInput().value
        },
        setInputValue: (option) => {
            reference.current.getInstance().setState({ selected: [option], showMenu: false })
            reference.current.getInstance().blur()
            onChange(option)
        },
    }));


    return (<AsyncTypeahead
        id={id}
        name={name}
        ref={reference}
        labelKey={labelKey}
        isLoading={isLoading}
        options={options}
        clearButton={true}
        filterBy={() => true}
        disabled={disabled}
        onSearch={onSearch}
        minLength={minLength}
        placeholder={placeholder}
        highlightOnlyResult={true}
        delay={500}
        onChange={onChange}
        onInputChange={onInputChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        useCache={false}
        inputProps={inputProps}
        searchText={t("commons.searching")}
        defaultSelected={defaultSelectedOptions}
    />)
})